import { IStepOption } from 'ngx-ui-tour-md-menu';
import { NavBarData } from './nav-bar.model';

export const navBarData: NavBarData[] = [
  {
    routeLink: '/clientName/dashboard/publication',
    label: 'new',
    icon: 'add.svg',
    hasAccess: false,
    role: ['admin_client', 'admin_wm', 'user_wm', 'user_client'],
  },

  {
    routeLink: '/clientName/dashboard/documents/list',
    label: 'documents',
    icon: 'file_present',
    hasAccess: false,
    role: ['admin_client', 'admin_wm', 'user_wm', 'user_client'],
  },
  {
    routeLink: '/clientName/dashboard/user-management',
    icon: `assets/images/nav-icon/user-management.svg`,
    label: 'User Management',
    hasAccess: false,
    isExpanded:true,

    items: [
      {
        routeLink: '/clientName/dashboard/user-management/user/list',
        label: 'Users',
        hasAccess: false,
        role: ['admin_client', 'admin_wm', 'superadmin'],
      },
      {
        routeLink: '/clientName/dashboard/user-management/admins/list',
        label: 'Admins',
        hasAccess: false,
        role: ['admin_wm', 'superadmin'],
      },
      {
        routeLink: '/clientName/dashboard/user-management/role/list',
        label: 'Roles',
        hasAccess: false,
        role: ['superadmin'],
      },
      {
        routeLink: '/clientName/dashboard/user-management/group/list',
        label: 'Permissions',
        hasAccess: false,
        role: ['superadmin'],
      },
      {
        routeLink: '/clientName/dashboard/user-management/client/list',
        label: 'Clients',
        hasAccess: false,
        role: [ 'superadmin'],
      },
    ],
  },
];

export const tourSteps: IStepOption[] = [
  {
    anchorId: 'new',
    title: 'Create new journal',
    content: 'Welcome to the demo tour!',
    enableBackdrop: true,
  },
  {
    anchorId: 'documents',
    title: 'Documents',
    content: 'Check Documents Here',
    enableBackdrop: true,
  },
];
